import { render, staticRenderFns } from "./TheAppHeader.vue?vue&type=template&id=1b067a04&scoped=true&"
import script from "./TheAppHeader.vue?vue&type=script&lang=js&"
export * from "./TheAppHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheAppHeader.vue?vue&type=style&index=0&id=1b067a04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b067a04",
  null
  
)

/* custom blocks */
import block0 from "./TheAppHeader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports